import { render, staticRenderFns } from "./WeightAndQualityCertificate.vue?vue&type=template&id=7a3d588e"
import script from "./WeightAndQualityCertificate.vue?vue&type=script&lang=js"
export * from "./WeightAndQualityCertificate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports